import ClientCustom from './errorCode/ClientCustom';
/**
 * 错误码
 */
export const ErrorCode = {
  ...ClientCustom.ErrorCode,
  NOT_IMPORT:'-100',
  // 后端对应错误码
  SYSTEM_BUSY: '-1',
};

const errorCodeMessage: any = {
  ...ClientCustom.errorCodeMessage,
  [ErrorCode.NOT_IMPORT]: 'error.not_import',
  // 后端对应错误码
  [ErrorCode.SYSTEM_BUSY]: 'error.system_busy',
  
};

export { errorCodeMessage };
